<template lang="pug">
  div.optimal-layout__col
    h2.optimal-layout__col_title Определение параметров объекта обращения с отходами
    form(
      @submit.prevent="onFormSubmit"
    )
      div.col
        .form__elem
          p.form__elem_label Тип объекта
          e-select.form__elem_input(
            :model="field"
            name="type"
            placeholder=""
            :options="paramsList"
          )
        .form__elem
          p.form__elem_label Год*
          e-select.form__elem_input(
            :model="field"
            name="year"
            placeholder=""
            :options="yearOptions"
          )
        .form__elem.form__elem_margin-bottom
          p.form__elem_label Географические координаты*
          e-input.form__elem_input(
            name="inputCoords"
            inputType="input"
            :model="field"
            placeholder="Например: 52.658699б, 41.879002"
          )
        .form__elem
          div(
            ref='map',
            style='height: 300px; width: 100%; z-index: 9; position: relative;'
          )
        .form__elem
          button.form-elem__btn(
            type="submit"
          ) Определить параметры
        .form__elem_wrapper
          h3 Количество объектов
          .form__elem
            p.form__elem_label обработки
            e-input.form__elem_input(
              name="processing"
              inputType="input"
              :model="field"
              :disabled="true"
            )
          .form__elem
            p.form__elem_label утилизации
            e-input.form__elem_input(
              name="utilization"
              inputType="input"
              :model="field"
              :disabled="true"
            )
          .form__elem
            p.form__elem_label обезвреживания
            e-input.form__elem_input(
              name="neutralization"
              inputType="input"
              :model="field"
              :disabled="true"
            )
          .form__elem
            p.form__elem_label хранения
            e-input.form__elem_input(
              name="storage"
              inputType="input"
              :model="field"
              :disabled="true"
            )
          .form__elem
            p.form__elem_label захоронения
            e-input.form__elem_input(
              name="burial"
              inputType="input"
              :model="field"
              :disabled="true"
            )
        .form__elem_wrapper
          h3 Максимальные расстояния
          .form__elem
            p.form__elem_label от объекта инфраструктуры
            e-input.form__elem_input(
              name="maxTkoDistance"
              inputType="input"
              :model="field"
              :disabled="true"
            )
          .form__elem
            p.form__elem_label от населенного пункта
            e-input.form__elem_input(
              name="maxGeoObjectDistance"
              inputType="input"
              :model="field"
              :disabled="true"
            )
          .form__elem
            p.form__elem_label до дороги
            e-input.form__elem_input(
              name="maxRoadDistanceTko"
              inputType="input"
              :model="field"
              :disabled="true"
            )
        .form__elem_wrapper
          h3 Минимальная мощность (тонн в год)
          .form__elem
            e-input.form__elem_input(
              name="minPowerTko"
              inputType="input"
              :model="field"
              :disabled="true"
            )
        .form__elem_wrapper
          h3 Количество МСиН
          .form__elem
            e-input.form__elem_input(
              name="countContainer"
              inputType="input"
              :model="field"
              :disabled="true"
            )
</template>

<script>
  import 'leaflet';
  import 'leaflet.markercluster';
  import 'leaflet/dist/leaflet.css';
  import 'leaflet.markercluster/dist/MarkerCluster.css';
  import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

  import {threads} from "@/api/api-endpoints";
  import axios from "axios";
  import optimalLayoutMixin from "@/app/access/mixins/optimal-layout-mixin";

  export default {
    data() {
      return {
        field: {
          type: '',
          year: '',
          coords: '',
          processing: '',
          neutralization: '',
          storage: '',
          utilization: '',
          burial: '',
          collection: '',
          maxTkoDistance: '',
          maxGeoObjectDistance: '',
          minPowerTko: '',
          maxRoadDistanceTko: '',
          countContainer: '',
        },
        markerCoords: {},
      }
    },
    mixins: [optimalLayoutMixin],
    props: {
      yearOptions: {
        type: Array,
        default: () => []
      },
      parametersList: {
        type: Array,
        default: () => []
      },
      mapCenter: {
        type: Object,
        default: () => ({}),
      }
    },
    methods: {
      async onFormSubmit() {
        await this.getInfoData(this.field)
      },
      getInfoData(field) {
        let {inputCoords, year} = field;
        if (!inputCoords || !year) {
          this.$e.errorBox('Заполните обязательные поля!');
          return;
        }
        const url = threads.infoData();
        const coords = inputCoords.split(",");
        const params = {
          lon: coords[1].trim(),
          lat: coords[0].trim(),
          year,
        }
        axios.get(url, {params})
          .then(response => (this.setData([params.lon, params.lat], response.data)))
          .catch(e => this.$e.errorBox('Ошибка получения данных! Повторите попытку'))
      },
      setData(coords, data) {
        this.setCoords(coords);
        this.resetParams();
        this.setParams(data);
      },
      setParams(fields) {
        this.parametersList.forEach((i) => {
          this.field[i.code] = i.count;
        });
        this.fieldsAdaptedToClient(fields)
      },
      resetParams() {
        this.parametersList.forEach((i) => {
          this.field[i.code] = '';
        });
      },
      fieldsAdaptedToClient(fields) {
        this.field.maxTkoDistance = fields['max_tko_distance'];
        this.field.maxGeoObjectDistance = fields['max_geo_object_distance'];
        this.field.minPowerTko = fields['min_power_tko'];
        this.field.maxRoadDistanceTko = fields['max_road_distance_tko'];
        this.field.countContainer = fields['count_container'];
      },
    },
  }
</script>
